import { Injectable } from '@angular/core';

@Injectable()
export class SelListOcurrence {

    listOcurrence: any = [
        {
            status: 'R', // R - Reversão, D - Devolução
            data: '13/09/2017',
            pedido: 332584,
            cod_cliente: 589,
            cliente: 'SUPERMERCADO TALISTE LTDA',
            cod_vd: 157,
            sv: 'DIRETA NIVEA',
            nf: 1,
            valor: 478.00,
            data_ft: '02/08/2017',
            motivo_dev: 'NF ERRADA',
            motorista: 'PAULO F.',
            observacao: 'Cliente disse que notas de troca são recebidas no CD do Tauste, ENDEREÇO É DIFERENTE DO QUE ESTÁ NA NOTA'
        },
        {
            status: 'R', // R - Reversão, D - Devolução
            data: '13/09/2017',
            pedido: 332584,
            cod_cliente: 589,
            cliente: 'SUPERMERCADO TALISTE LTDA',
            cod_vd: 157,
            sv: 'DIRETA NIVEA',
            nf: 1,
            valor: 478.00,
            data_ft: '02/08/2017',
            motivo_dev: 'NF ERRADA',
            motorista: 'PAULO F.',
            observacao: 'Cliente disse que notas de troca são recebidas no CD do Tauste, ENDEREÇO É DIFERENTE DO QUE ESTÁ NA NOTA'
        },
        {
            status: 'R', // R - Reversão, D - Devolução
            data: '13/09/2017',
            pedido: 332584,
            cod_cliente: 589,
            cliente: 'SUPERMERCADO TALISTE LTDA',
            cod_vd: 157,
            sv: 'DIRETA NIVEA',
            nf: 1,
            valor: 478.00,
            data_ft: '02/08/2017',
            motivo_dev: 'NF ERRADA',
            motorista: 'PAULO F.',
            observacao: 'Cliente disse que notas de troca são recebidas no CD do Tauste, ENDEREÇO É DIFERENTE DO QUE ESTÁ NA NOTA'
        },
        {
            status: 'D', // R - Reversão, D - Devolução
            data: '13/09/2017',
            pedido: 332584,
            cod_cliente: 589,
            cliente: 'SUPERMERCADO TALISTE LTDA',
            cod_vd: 157,
            sv: 'DIRETA NIVEA',
            nf: 1,
            valor: 478.00,
            data_ft: '02/08/2017',
            motivo_dev: 'NF ERRADA',
            motorista: 'PAULO F.',
            observacao: 'Cliente disse que notas de troca são recebidas no CD do Tauste, ENDEREÇO É DIFERENTE DO QUE ESTÁ NA NOTA'
        },
        {
            status: 'R', // R - Reversão, D - Devolução
            data: '13/09/2017',
            pedido: 332584,
            cod_cliente: 589,
            cliente: 'SUPERMERCADO TALISTE LTDA',
            cod_vd: 157,
            sv: 'DIRETA NIVEA',
            nf: 1,
            valor: 478.00,
            data_ft: '02/08/2017',
            motivo_dev: 'NF ERRADA',
            motorista: 'PAULO F.',
            observacao: 'Cliente disse que notas de troca são recebidas no CD do Tauste, ENDEREÇO É DIFERENTE DO QUE ESTÁ NA NOTA'
        },
        {
            status: 'D', // R - Reversão, D - Devolução
            data: '13/09/2017',
            pedido: 332584,
            cod_cliente: 589,
            cliente: 'SUPERMERCADO TALISTE LTDA',
            cod_vd: 157,
            sv: 'DIRETA NIVEA',
            nf: 1,
            valor: 478.00,
            data_ft: '02/08/2017',
            motivo_dev: 'NF ERRADA',
            motorista: 'PAULO F.',
            observacao: 'Cliente disse que notas de troca são recebidas no CD do Tauste, ENDEREÇO É DIFERENTE DO QUE ESTÁ NA NOTA'
        }
    ];

  constructor() { }
}